var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgReport = function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.763,
    height: 21.535
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Report_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.847 1.035)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-report-problem",
    d: "M1.5 20.948h20.61L11.8 3z",
    transform: "translate(-.041 -.948)",
    fill: "url(#Report_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-report-problem",
    d: "M0 20h22.069L11.455.763 11.034 0z",
    fill: "none",
    stroke: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 99",
    d: "M11 7h2v7h-2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 100",
    width: 2,
    height: 2,
    rx: 1,
    transform: "translate(11 15)",
    fill: "#fff"
  }))));
};
export default SvgReport;